import { IActionComparator, INamespaceActionCreator, IReducer } from '@omaze/redux';

import { EMAIL_CAPTURE_ACTION } from '../email-capture-actions';
import {
    createEmailCaptureActionComparator,
    createEmailCaptureActionCreatorFactory,
    createEmailCaptureReducerFactory,
} from '../email-capture.factories';
import { ErrorType, IEmailCaptureState, Status } from '../email-capture.state';

export const createSignUpEmailCaptureStartAction: INamespaceActionCreator = createEmailCaptureActionCreatorFactory(
    EMAIL_CAPTURE_ACTION.SIGN_UP_EMAIL_CAPTURE_START,
    (payload: string): string => {
        return payload;
    }
);

export const signUpEmailCaptureStartReducer: IReducer<IEmailCaptureState> = createEmailCaptureReducerFactory(
    EMAIL_CAPTURE_ACTION.SIGN_UP_EMAIL_CAPTURE_START,
    (state: IEmailCaptureState): void => {
        state.status = Status.LOADING;
        state.error = ErrorType.INITIAL;
    }
);

export const isSignUpEmailCaptureStartAction: IActionComparator = createEmailCaptureActionComparator(
    EMAIL_CAPTURE_ACTION.SIGN_UP_EMAIL_CAPTURE_START,
);
